import { FaDumbbell, FaUsers } from "react-icons/fa";
import AdminNavbar from "./AdminNavbar";
import { useEffect, useState } from "react";
import { db } from "../Firebase";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

export default function Dashboard() {

    const [pro, setpro] = useState([]);
    const [data, setdata] = useState([]);

    function fetchprograms() {
        db.collection("programs").onSnapshot((succ) => {
            setpro(succ.docs);
        })
    }

    function fetchdata() {
        db.collection("form").onSnapshot((succ) => {
            setdata(succ.docs);
        })
    }

    useEffect(() => {
        fetchprograms();
        fetchdata();
    }, [])

    const list = [
        { icon: <FaUsers color="red" />, bg: "bg-danger-subtle", number: data.length, name: "Total Enquiries" },
        // { icon: <FaUsers color="green" />, bg: "bg-success-subtle", number: "15", name: "Consultation Requests" },
        { icon: <FaDumbbell color="blue" />, bg: "bg-primary-subtle", number: pro.length, name: "Active Programs" },
        // { icon: <FaUsers color="orange" />, bg: "bg-warning-subtle", number: "125", name: "Testimonials" },
    ];

    const chartData = [
        { name: "💪 Muscle Building", value: 35 },
        { name: "👨‍💻 Online Personal Training", value: 25 },
        { name: "🥗 Diet & Nutrition", value: 25 },
        { name: "🔥 Body Recomposition", value: 20 },
        { name: "🏋️ Fat Loss", value: 20 }
    ];

    const COLORS = ["#dc3545", "#198754", "#0d6efd", "#ff7207", "#ffc107"];

    return (
        <>
            <div className="bg-light min-vh-100">
                <AdminNavbar />
                <div className="container-fluid px-4 py-3">
                    <div className="border-0 rounded-4 p-1 mb-3">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h3 className="fw-bold mb-2">Good Morning, Admin! 👋</h3>
                                <p className="text-secondary mb-0">Welcome back! Here's a quick overview of your fitness coaching business.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4 mb-2">
                        {list.map((row) => (
                            <div className="col-lg-3">
                                <div className={`card ${row.bg} border-0 rounded-4 p-3`}>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h4>{row.name}</h4>
                                            <h3 className="fw-bold">{row.number}</h3>
                                        </div>
                                        <span className="fs-1">
                                            {row.icon}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-8">
                            <div className="card border-0 rounded-4">
                                <div className="card-body">
                                    <h5 className="fw-bold mb-4">
                                        Active Programs
                                    </h5>
                                    <div className="table-responsive">
                                        <table className="table align-middle">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Image</th>
                                                    <th>Name</th>
                                                    <th>Duration</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pro.slice(0, 5).map((row, index) => (
                                                    <>
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <img src={row.data().img} className="img-fluid rounded-circle" style={{ width: 50, height: 50 }} />
                                                            </td>
                                                            <td>{row.data().icon} {row.data().name}</td>
                                                            <td>{row.data().duration}</td>
                                                        </tr>
                                                    </>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="card border-0 rounded-4 h-100">
                                <div className="card-body">
                                    <h5 className="fw-bold mb-4">Program Distribution</h5>
                                    <ResponsiveContainer width="100%" height={280}>
                                        <PieChart>
                                            <Pie data={chartData} dataKey="value" nameKey="name" innerRadius={70} outerRadius={100} paddingAngle={5}>
                                                {chartData.map((entry, index) => (
                                                    <Cell key={index} fill={COLORS[index]} />
                                                ))}
                                            </Pie>
                                            <Tooltip />
                                        </PieChart>
                                    </ResponsiveContainer>
                                    <div className="mt-3">
                                        {chartData.map((item, index) => (
                                            <div className="d-flex justify-content-between mb-2" key={index}>
                                                <span>
                                                    <span className="me-2 rounded-circle d-inline-block" style={{ width: 12, height: 12, background: COLORS[index] }}></span>
                                                    {item.name}
                                                </span>
                                                <strong>{item.value}%</strong>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}